import PropTypes from "prop-types";
import React from "react";

const alertColors = {
  default: "gray",
  warning: "yellow",
  success: "green",
  danger: "red",
};
export const Alert = ({ variant, children, ...rest }) => {
  const color = alertColors[variant] || "gray";
  return (
    <div
      className={`py-3 px-5 my-4 bg-${color}-100 text-${color}-900 text-sm rounded-md border border-${color}-700`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Alert;

Alert.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
};
